module.exports = __webpack_public_path__ + "static/Recording_rules-9f360695bb72aa9a7aa7de950f91bf25.png";